<section class="location" #intro id="location">
  <h2>
    <div class="vertical">Unsere</div>
    <div class="headline">
      <span>Dart-Location</span><br>
      in Lohfelden - Kassel
    </div>
  </h2>
  <p>
    Unser Dart Rock Café in Lohfelden bei Kassel ist mehr als nur eine Kneipe – es ist dein Treffpunkt für Dart,
    gute Drinks und gesellige Abende. Zentral gelegen und leicht zu erreichen, erwartet dich bei uns echtes Pub-Feeling
    kombiniert mit moderner Ausstattung. Ob du auf spannende Matches an unseren Dartautomaten aus bist, einfach ein
    <a [routerLink]="['/magazin/dart-bier-warum-diese-kombi-in-kassel-unschlagbar-ist']">kühles Bier</a> mit Freunden genießen möchtest oder die besondere Atmosphäre suchst – bei uns bist du genau richtig.
  </p>

  <div class="grid">
    <div class="element"
         *ngFor="let image of images; let i = index"
       [ngClass]="{
         'element': true,
         'show': show,
         'active': activeIndices.includes(i)
       }"
         (click)="toggleActive(i)"
         [ngStyle]="show ? { 'background-image': 'url(' + getImageUrl(image) + ')'} : null"
    ></div>
  </div>
</section>
